export function formatSortString(sortBy, isDescending) {
    if (!sortBy) {
        return "";
    }

    return `${sortBy}_${isDescending ? "desc" :  "asce"}`
}

export function decodeSortString(sortString) {
    const sortParameters = sortString?.split("_") ?? ["", ""];

    return [sortParameters[0], sortParameters[1] === "desc"]
}

export function splitDateTime(dateTime) {
    return dateTime?.split('T') ?? undefined;
}

/** Converts the given object to form data. 
 * Requires that the name of every property matches what the reciever of the form data expects. */
export function packIntoFormData(object) {
    let formData = new FormData();

    if (object === null) {
        return formData;
    }

    objectToFormData(object, formData);

    console.log(formData);

    for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }
    return formData;
}

function objectToFormData(object, formData, prefix = undefined) {

  
    for (const property in object) {
        if (object[property] instanceof Blob) {
            const appendName = `${prefix ? prefix + '.' : ''}${property}`
            formData.append(appendName, object[property],appendName + '.png');
        } else if (Array.isArray(object[property])) {

            unwrapArray(object[property], formData, prefix ? prefix + '.' + property : property);
        } else if (typeof object[property] === 'object' && object[property] !== null) {

            objectToFormData(object[property], formData, prefix ? prefix + '.' + property : property);
        } else if (object[property]) {


            formData.append(`${prefix ? prefix + '.' : ''}${property}`, object[property]);
        }



    }
}

function unwrapArray(array, formData, prefix) {
    array.forEach((item, index) => {
        if (item instanceof Blob) {
            formData.append(`${prefix}[${index}]`, item ?? '');
        } else if (typeof item === 'object' && item !== null) {
            objectToFormData(item, formData, `${prefix}[${index}]`);
        } else if (item) {
            formData.append(`${prefix}[${index}]`, item ?? '');
        }
    });
}

export function isHttpUrl(str) {
  return str.startsWith("http://") || str.startsWith("https://");
}